/**
 * Created by hl on 2018/12/28.
 */
import BizXfLoupanItem from './biz-xf-loupan-item.vue';

export default BizXfLoupanItem;
